import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import { getToken } from "@/utils/auth";
import { isRelogin } from "@/utils/request";
import { getRouteByRoles, hasRole } from "@/utils/permission";

const whiteList = [
  "/login",
  "/register",
  "/skyBox",
  "/home",
  "/help",
  "/ai", // 已下线页面：保留白名单用于旧链接重定向到首页
  "/product",
  "/more",
  "/dev",
  "/404",
  "/student-class",
];

// 支持动态路由匹配的白名单
const dynamicWhiteList = [
  "/student-class", // 匹配 /student-class/:id
];

/**
 * 检查路径是否在白名单中（支持动态路由）
 * @param {string} path - 当前路径
 * @returns {boolean} - 是否在白名单中
 */
function isInWhiteList(path) {
  // 检查精确匹配
  if (whiteList.indexOf(path) !== -1) {
    return true;
  }

  // 检查动态路由匹配
  return dynamicWhiteList.some((pattern) => {
    return path.startsWith(pattern + "/");
  });
}

router.beforeEach((to, from, next) => {
  if (getToken()) {
    /* has token*/
    if (isInWhiteList(to.path)) {
      next();
    } else {
      if (store.getters.roles.length === 0) {
        isRelogin.show = true;
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch("GetInfo")
          .then(() => {
            isRelogin.show = false;
            next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
          })
          .catch((err) => {
            store.dispatch("LogOut").then(() => {
              Message.error(err);
              next({ path: "/" });
            });
          });
      } else {
        // 检查路由权限
        const userRoles = store.getters.roles;
        const routeMeta = to.meta;

        // 如果路由需要特定角色
        if (routeMeta.roles && routeMeta.roles.length > 0) {
          if (hasRole(userRoles, routeMeta.roles)) {
            next();
          } else {
            Message.warning("您没有访问该页面的权限");
            // 重定向到用户默认页面
            const defaultRoute = getRouteByRoles(userRoles);
            next({ path: defaultRoute });
          }
        } else {
          next();
        }
      }
    }
  } else {
    // 没有token
    if (isInWhiteList(to.path)) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`); // 否则全部重定向到登录页
    }
  }
});
